import { z } from "zod";
import { Uuid,success } from "@secretaa/http-contract";
import { TickResult } from "./ai-accounting.ts";
/** Transport identity only. Data owner chooses the due cursor and bounds the work. */
export const VERSION="1.0.0";
export const PATH="/internal/v1/ai/accounting/wakeup";
export const Command=z.object({workspaceId:Uuid,batchId:Uuid}).strict();
export type Command=z.infer<typeof Command>;
/** Queue ACK is a bounded maintenance attempt, never proof that all liabilities are settled. */
export const Result=z.object({batchId:Uuid,accounting:TickResult.refine(r=>r.pending<=r.processed&&(r.status==="PROCESSED"?r.processed===1:r.processed===0)&&(r.revision===0||r.nextAttemptAt!==null),"TICK_RESULT_INVALID")}).strict();
export type Result=z.infer<typeof Result>;
export const Response=success(Result);
